import { onPageLoad } from '@/js/modules/page_load';
// Get the project subnav

onPageLoad(() => {
  const projectSubnav = document.querySelector('.project-subnav');

  // calculate width of every nav item and store it in data attribute to use it later
  const calculateWidthOfNavItems = () => {
    const projectSubnavLinks = projectSubnav.querySelectorAll('.project-subnav__item');
    for (const item of projectSubnavLinks) {
      const itemMarginRight = parseInt(window.getComputedStyle(item).marginRight);
      const itemWidth = item.offsetWidth;
      item.dataset.width = itemMarginRight + itemWidth;
    }
  };

  // Auto scroll to selected item on mobile
  const scrollToSelectedItem = () => {
    const selectedItem = projectSubnav.querySelector('.project-subnav__item--selected');

    if (selectedItem) {
      const itemOffsetLeft = selectedItem.offsetLeft;
      const targetScrollPosition = itemOffsetLeft - 64;

      projectSubnav.scrollTo({ left: Math.max(0, targetScrollPosition) });
    }
  };

  // Show the right-fade and left-fade for mobile
  const updateFadeVisibility = () => {
    const isMobile = window.innerWidth < 990;
    const canScrollRight =
      projectSubnav.scrollLeft + projectSubnav.clientWidth < projectSubnav.scrollWidth - 1;
    const canScrollLeft = projectSubnav.scrollLeft > 1;

    projectSubnav.classList.toggle('project-subnav--with-fade-right', isMobile && canScrollRight);
    projectSubnav.classList.toggle('project-subnav--with-fade-left', isMobile && canScrollLeft);
  };

  // Mobile view (under 990px)
  let wasMobileView = null;

  const updateProjectSubnav = () => {
    const dropdownTrigger = projectSubnav.querySelector('.project-subnav__item--dropdown-trigger');
    const isMobileView = window.innerWidth < 990;

    projectSubnav.style.opacity = 1;

    if (isMobileView) {
      if (wasMobileView === false && dropdownTrigger) {
        const dropdown = dropdownTrigger.querySelector('.project-subnav__dropdown');
        const itemsInDropdown = dropdown.querySelectorAll('.project-subnav__item');

        for (const item of itemsInDropdown) {
          projectSubnav.insertBefore(item, dropdownTrigger);
        }

        dropdownTrigger.style.display = 'none';

        scrollToSelectedItem();
      } else if (wasMobileView === null && dropdownTrigger) {
        dropdownTrigger.style.display = 'none';

        scrollToSelectedItem();
      }

      wasMobileView = true;
      return;
    }

    // Desktop (990px and above)
    if (wasMobileView === true) {
      calculateWidthOfNavItems();
    }

    wasMobileView = false;

    const projectSubnavWidth = projectSubnav.offsetWidth;
    const projectSubnavLinks = projectSubnav.querySelectorAll(
      '.project-subnav__item:not(.project-subnav__item--dropdown-trigger)'
    );

    if (dropdownTrigger) {
      // Show the dropdown trigger on desktop
      dropdownTrigger.style.display = '';

      // get widest nav link and use it later to determine space of dropdown to the edge of a browser
      function getWidestNavLink(items) {
        const widestNavLink = Math.max(...items.map((item) => item.dataset.width));
        return widestNavLink;
      }

      const widestNavLink = getWidestNavLink([...projectSubnavLinks]);
      let widthOfChildren = 0;

      // find position of breaking point element
      let breakingPosition;
      for (const [i, item] of projectSubnavLinks.entries()) {
        widthOfChildren = widthOfChildren + parseInt(item.dataset.width);
        if (widthOfChildren + widestNavLink > projectSubnavWidth) {
          breakingPosition = i;
          break;
        }
      }

      if (breakingPosition) {
        // insert elements that are before breaking point into nav
        for (let i = 0; i < breakingPosition && i < projectSubnavLinks.length; i++) {
          projectSubnav.insertBefore(projectSubnavLinks[i], dropdownTrigger);
        }
        // insert elements that are after breaking point into dropdown
        for (let i = breakingPosition; i < projectSubnavLinks.length; i++) {
          dropdownTrigger.querySelector('.project-subnav__dropdown').append(projectSubnavLinks[i]);
        }
      } else {
        // if there's no breaking point - insert all elements into nav
        for (const item of projectSubnavLinks) {
          projectSubnav.insertBefore(item, dropdownTrigger);
        }
      }
    }
  };

  if (projectSubnav) {
    calculateWidthOfNavItems();
    updateProjectSubnav();
    updateFadeVisibility();
    projectSubnav.addEventListener('scroll', updateFadeVisibility);

    window.onresize = () => {
      updateProjectSubnav();
      updateFadeVisibility();
    };
  } else {
    // A Turbo visit away from a project page keeps the window, so drop the old page's handler.
    window.onresize = null;
  }
});
